const Activate = () => import('@/pages/account/activate/activate.vue');
const ResetPasswordInit = () => import('@/pages/account/reset-password/init/reset-password-init.vue');
const ResetPasswordFinish = () => import('@/pages/account/reset-password/finish/reset-password-finish.vue');
const RolesRegister = () => import('@/pages/roles-register/roles-register.vue');

export default [
  {
    path: '/account/activate',
    name: 'Activate',
    component: Activate,
    meta: {
      layout: 'registration-layout',
    },
  },
  {
    path: '/account/reset/request',
    name: 'ResetPasswordInit',
    component: ResetPasswordInit,
    meta: {
      layout: 'registration-layout',
    },
  },
  {
    path: '/account/reset/finish',
    name: 'ResetPasswordFinish',
    component: ResetPasswordFinish,
    meta: {
      layout: 'registration-layout',
    },
  },
  {
    path: '/:role/anmelden',
    name: 'RolesRegister',
    component: RolesRegister,
    meta: {
      layout: 'registration-layout',
    },
  },
  {
    path: '/:role/anmelden2',
    name: 'RolesRegister2',
    component: RolesRegister,
    meta: {
      layout: 'registration-layout',
    },
  },
];
